import _createClass from "/Users/arsenghazaryan/titanoid/hayape/hayape/web/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/arsenghazaryan/titanoid/hayape/hayape/web/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/Users/arsenghazaryan/titanoid/hayape/hayape/web/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/Users/arsenghazaryan/titanoid/hayape/hayape/web/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/arsenghazaryan/titanoid/hayape/hayape/web/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import Connector from "@walletconnect/core";
import * as cryptoLib from "@walletconnect/iso-crypto";

var WalletConnect = /*#__PURE__*/function (_Connector) {
  _inherits(WalletConnect, _Connector);

  var _super = _createSuper(WalletConnect);

  function WalletConnect(connectorOpts, pushServerOpts) {
    _classCallCheck(this, WalletConnect);

    return _super.call(this, {
      cryptoLib: cryptoLib,
      connectorOpts: connectorOpts,
      pushServerOpts: pushServerOpts
    });
  }

  return _createClass(WalletConnect);
}(Connector);

export default WalletConnect;